import { useMutation, useQueryClient } from '@tanstack/react-query';
import useHttpClient from './useHttpClient';

interface IUpdateRecentProjectsParams {
  userId: string;
  projectId: number;
}

const useMutateRecentProjects = () => {
  const httpClient = useHttpClient();
  const queryClient = useQueryClient();

  return useMutation<any, Error, IUpdateRecentProjectsParams>({
    mutationFn: async ({ userId, projectId }) => {
      const response = await httpClient.post(`/users/${userId}/recentprojects/${projectId}`, {
        projectId,
      });
      return response.data;
    },
    onSuccess: (data, variables) => {
      // Invalidate recent projects queries for this specific user
      queryClient.invalidateQueries({
        queryKey: ['recentProjects', variables.userId]
      });
    },
    onError: (error) => {
      console.error('Failed to update recent projects:', error);
    },
  });
};

export default useMutateRecentProjects;
